import { render } from "./ctrl-btn-click-dbclick.vue?vue&type=template&id=3f4036e6&scoped=true&ts=true"
import script from "./ctrl-btn-click-dbclick.vue?vue&type=script&lang=ts"
export * from "./ctrl-btn-click-dbclick.vue?vue&type=script&lang=ts"

import "./ctrl-btn-click-dbclick.vue?vue&type=style&index=0&id=3f4036e6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4036e6"]])

export default __exports__